export default __webpack_public_path__ + "static/media/ib2b_b2b.548566c5.png";